import { render, staticRenderFns } from "./SalonReservedConfirm.vue?vue&type=template&id=71bd624e&scoped=true&"
import script from "./SalonReservedConfirm.vue?vue&type=script&lang=js&"
export * from "./SalonReservedConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SalonReservedConfirm.vue?vue&type=style&index=0&id=71bd624e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd624e",
  null
  
)

export default component.exports